export default __webpack_public_path__ + "0528dae195431d2072cfe5dd74f9cea8.svg";